import { z } from "zod";

const LessonLimitationSchema = z.object({
  grammarLimit: z.array(z.string()),
  grammarFocus: z.array(z.string()),
  wordLimit: z.array(z.string()),
  wordFocus: z.array(z.string()),
});

export type LessonLimitation = z.infer<typeof LessonLimitationSchema>;

export const LessonSchema = z.object({
  id: z.string(),
  name: z.string(),
  parentId: z.string().nullable(),
  originalLessonId: z.string().nullable(),
  isTrash: z.boolean(),
  isDeleted: z.boolean(),
  deletedAt: z.date().nullable().optional(),
  isHidden: z.boolean(),
  imageId: z.string().nullable(),
  // Internal/cached field, not exposed on the GraphQL Lesson type — must be optional, not
  // just nullable, so clients validating a GraphQL response never fail on its absence.
  imageKey: z.string().nullable().optional(),
  grammarLimit: z.string().nullable().optional(),
  isPublic: z.boolean(),
  schoolIds: z.array(z.string()),
  createdAt: z.date(),
  updatedAt: z.date(),
  lessonNumber: z.number().int().min(1).optional(),
  isLinkedCopy: z.boolean().default(false),
  sortOrder: z.number().nullable(),
});

export const LessonsSchema = z.array(LessonSchema);

export type Lesson = z.infer<typeof LessonSchema>;
